import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'leadReplyNotifs';
const load = () => { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; } };
const save = (arr) => localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));

const leadReplyNotifsSlice = createSlice({
  name: 'leadReplyNotifs',
  initialState: { notifications: load() },
  reducers: {
    addLeadReplyNotif(state, action) {
      const notif = action.payload; // { leadId, agencyName, from, subject, messageId, timestamp }
      const exists = state.notifications.some(
        n => n.leadId === notif.leadId && n.messageId === notif.messageId
      );
      if (!exists) {
        state.notifications.unshift(notif);
        if (state.notifications.length > 50) state.notifications.length = 50;
        save(state.notifications);
      }
    },
    dismissLeadReplyNotif(state, action) {
      state.notifications = state.notifications.filter(n => n.leadId !== action.payload);
      save(state.notifications);
    },
    clearAllLeadReplyNotifs(state) {
      state.notifications = [];
      save([]);
    },
  },
});

export const { addLeadReplyNotif, dismissLeadReplyNotif, clearAllLeadReplyNotifs } = leadReplyNotifsSlice.actions;
export default leadReplyNotifsSlice.reducer;
